import React from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';
import FlatButton from 'material-ui/FlatButton';

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = { stepIndex: 0 };
    autoBind(this);
  }

  handleNext = () => {
    const { stepIndex } = this.state;
    if (stepIndex < 2) {
      this.setState({ stepIndex: stepIndex + 1 });
    }
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  render() {
    const { stepIndex } = this.state;
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-8 col-md-offset-2 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <Stepper linear={false} activeStep={stepIndex}>
                  <Step>
                    <StepButton onClick={() => this.setState({ stepIndex: 0 })}>
                      Manage Facilities
                    </StepButton>
                  </Step>
                  <Step>
                    <StepButton onClick={() => this.setState({ stepIndex: 1 })}>
                      Create Marker Types
                    </StepButton>
                  </Step>
                  <Step>
                    <StepButton onClick={() => this.setState({ stepIndex: 2 })}>
                      Invite users
                    </StepButton>
                  </Step>
                </Stepper>
                <div style={{ margin: 16 }}>
                  {stepIndex === 0 && (
                    <div className="row">
                      <div className="col-sm-6">
                        <p>
                          Grab hardware regular footed JFA frontside disaster
                          front foot impossible. Half-flip flypaper heel flip
                          hardware rocket air steps Rudy Johnson. Girl smith
                          grind stalefish lipslide crail slide birdie 720. Pump
                          kickturn casper slide Thunder transfer crailtap
                          baseplate. Pop shove-it trucks spine boneless egg
                          plant gap. Vert slappy gnar bucket frontside pogo
                          bearings. Chris Pastras hardware opposite footed
                          slappy mini ramp helipop varial. Goofy footed 540
                          skater yeah slam varial. Blunt heel flip Primo slide
                          hard flip manual frontside Randy Ruiz. Casper slide
                          baseplate casper sick finger flip rip grip.
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <img
                          src="/img/blurred_nashville.jpg"
                          alt="How to use the app"
                          className="responsive"
                        />
                      </div>
                    </div>
                  )}
                  {stepIndex === 1 && (
                    <div className="row">
                      <div className="col-sm-6">
                        <img
                          src="/img/blurred_nashville.jpg"
                          alt="How to use the app"
                          className="responsive"
                        />
                      </div>
                      <div className="col-sm-6">
                        <p>
                          Grab hardware regular footed JFA frontside disaster
                          front foot impossible. Half-flip flypaper heel flip
                          hardware rocket air steps Rudy Johnson. Girl smith
                          grind stalefish lipslide crail slide birdie 720. Pump
                          kickturn casper slide Thunder transfer crailtap
                          baseplate. Pop shove-it trucks spine boneless egg
                          plant gap. Vert slappy gnar bucket frontside pogo
                          bearings. Chris Pastras hardware opposite footed
                          slappy mini ramp helipop varial. Goofy footed 540
                          skater yeah slam varial. Blunt heel flip Primo slide
                          hard flip manual frontside Randy Ruiz. Casper slide
                          baseplate casper sick finger flip rip grip.
                        </p>
                      </div>
                    </div>
                  )}
                  {stepIndex === 2 && (
                    <div className="row">
                      <div className="col-sm-6">
                        <p>
                          Grab hardware regular footed JFA frontside disaster
                          front foot impossible. Half-flip flypaper heel flip
                          hardware rocket air steps Rudy Johnson. Girl smith
                          grind stalefish lipslide crail slide birdie 720. Pump
                          kickturn casper slide Thunder transfer crailtap
                          baseplate. Pop shove-it trucks spine boneless egg
                          plant gap. Vert slappy gnar bucket frontside pogo
                          bearings. Chris Pastras hardware opposite footed
                          slappy mini ramp helipop varial. Goofy footed 540
                          skater yeah slam varial. Blunt heel flip Primo slide
                          hard flip manual frontside Randy Ruiz. Casper slide
                          baseplate casper sick finger flip rip grip.
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <img
                          src="/img/blurred_nashville.jpg"
                          alt="How to use the app"
                          className="responsive"
                        />
                      </div>
                    </div>
                  )}
                  <div className="row end-xs">
                    <div className="col-sm-12">
                      <div style={{ marginTop: 12 }}>
                        <FlatButton
                          label="Back"
                          disabled={stepIndex === 0}
                          primary={true}
                          onClick={this.handlePrev}
                          style={{ marginRight: 12 }}
                        />
                        <FlatButton
                          label="Next"
                          disabled={stepIndex === 2}
                          primary={true}
                          onClick={this.handleNext}
                          style={{ marginRight: 12 }}
                        />
                        <RaisedButton
                          label="Finish"
                          primary={true}
                          onClick={this.handleNext}
                          containerElement={<Link to="/map" />}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Paper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.jsx